module.exports = __webpack_public_path__ + "static/media/SLANTED FLAP.aae33194.svg";